import { GiftReceiptRequestZodArraySchema } from "@redotech/redo-model/gift-receipt/gift-receipt-request";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getGiftReceiptRequests = {
  name: "getGiftReceiptRequests" as const,
  input: z.object({
    limit: z.number().min(1).max(100).default(50).optional(),
    offset: z.number().min(0).default(0).optional(),
    pageContinue: z.string().optional(),
    sortKey: z.string().optional(),
    sortDirection: createEnum(["asc", "desc"]).optional(),
  }),

  output: z.object({
    requests: GiftReceiptRequestZodArraySchema,
    pageNext: z.string().nullish(),
  }),
};
